import { takeLatest, put } from 'redux-saga/effects';
import createCrudService from '../../services/crudservice';
import {
  doCrudCall,
  SAVING_MSG,
  UPDATING_MSG,
  DELETING_MSG,
  LOADING_MSG,
  createRecordSuccess,
  updateRecordSuccess,
  deleteRecordSuccess
} from '../../utils/crudSagaHelper';

import {
  getEmployeeRewardListSuccess,
  getEmployeeRewardListFail,
  getEmployeeRewardDetailsSuccess,
  getEmployeeRewardDetailsFail,
  getEmployeeRewardLeaderboardSuccess,
  getEmployeeRewardLeaderboardFail,
  getEmployeeRewardDashboardSuccess,
  getEmployeeRewardDashboardFail,
  getMyRewardSummarySuccess,
  getMyRewardSummaryFail,
} from './employeeRewardState';

const crudService = createCrudService('api/v1/rewards/employee-rewards');
const rewardService = createCrudService('api/v1/rewards');

const redirectData = {
  route: '/console/rewards',
  mode: 'list',
  recordId: 0
};

const modelName = 'Employee Reward';
const modelId = 'erw_id';

function* getEmployeeRewardList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeRewardListSuccess,
    getEmployeeRewardListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeRewardDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getEmployeeRewardDetailsSuccess,
    getEmployeeRewardDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doEmployeeRewardCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getEmployeeRewardDetailsSuccess,
    getEmployeeRewardDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    SAVING_MSG
  );
}

function* doEmployeeRewardUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getEmployeeRewardDetailsSuccess,
    getEmployeeRewardDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    UPDATING_MSG
  );
}

function* doEmployeeRewardDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getEmployeeRewardDetailsSuccess,
    getEmployeeRewardDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode: data.payload.mode },
    DELETING_MSG
  );
}

function* getEmployeeRewardLeaderboard(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeRewardLeaderboardSuccess,
    getEmployeeRewardLeaderboardFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeRewardDashboard() {
  yield doCrudCall(
    () => rewardService.doGetRequest('dashboard'),
    getEmployeeRewardDashboardSuccess,
    getEmployeeRewardDashboardFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getMyRewardSummary() {
  try {
    const response = yield rewardService.doGetRequest('hyvid-points'); 

    yield put(getMyRewardSummarySuccess(response)); 
  } catch (error) {
    yield put(getMyRewardSummaryFail(error));
  }
}

function* employeeRewardSaga() {
  yield takeLatest('employeeReward/getEmployeeRewardList', getEmployeeRewardList);
  yield takeLatest('employeeReward/getEmployeeRewardDetails', getEmployeeRewardDetails);
  yield takeLatest('employeeReward/doEmployeeRewardCreate', doEmployeeRewardCreate);
  yield takeLatest('employeeReward/doEmployeeRewardUpdate', doEmployeeRewardUpdate);
  yield takeLatest('employeeReward/doEmployeeRewardDelete', doEmployeeRewardDelete);
  yield takeLatest('employeeReward/getEmployeeRewardLeaderboard', getEmployeeRewardLeaderboard);
  yield takeLatest('employeeReward/getEmployeeRewardDashboard', getEmployeeRewardDashboard);
  yield takeLatest('employeeReward/getMyRewardSummary', getMyRewardSummary);
}

export default employeeRewardSaga;